import axios from '../axios';
import EventBus from 'eventing-bus';
import { all, takeEvery, call, put, delay } from 'redux-saga/effects';

import { setSinglePageData } from './index';

function* getSinglePageData({ payload }) {
  const { error, response } = yield call(getCall, `/objects/${payload['objectType']}/${payload['id']}`);
  if (error) {
    EventBus.publish("error", error['response']?.['data']?.['message'] || "Error fetching single page data");
    yield put({ type: 'SET_LOADING', payload: false });
  }
  else if (response) yield put(setSinglePageData(response['data']['body']));
}

// Root Saga
export default function* singlePageSaga() {
  yield all([
    yield takeEvery('GET_SINGLE_PAGE_DATA', getSinglePageData),
  ]);
}

function postCall({ path, payload }) {
  return axios
    .post(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function getCall(path) {
  return axios
    .get(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function deleteCall(path) {
  return axios
    .delete(path)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function putCall({ path, payload }) {
  return axios
    .put(path, payload)
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}

function postFileCall({ path, payload }) {
  return axios
    .post(path, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => ({ response }))
    .catch(error => {
      if (error.response?.status === 401) EventBus.publish("tokenExpired");
      return { error };
    });
}